export const TOUR_TARGETS = {
  WELCOME: '#tour-welcome-anchor',
  SWITCH_TABS: '#tour-switch-tabs',
  ITEM_UNREAD: '#tour-item-unread',
  ITEM_REPLIED: '#tour-item-replied',
  ITEM_REPLY_READ: '#tour-item-replyRead',
  ITEM_REPLY_REJECTED: '#tour-item-replyRejected',
  ITEM_READ: '#tour-item-read',
  ITEM_BLOCKED: '#tour-item-blocked',
  SWITCH_TABS_CONTACT: '#tour-switch-tabs-contact',
  CONTACTS_TITLE: '#tour-contacts-title',
  CONTACT_BLOCKED: '#tour-contact-blocked',
  VIEWING_MESSAGES_ANCHOR: '#tour-post-view-anchor',
  VIEWING_MESSAGES: '#tour-viewing-messages',
  PLAY_VOICE: '#tour-play-voice',
  TRACK_REPLIES: '#tour-track-replies-0',
  SEND_REPLY: '#tour-send-reply',
  TRACK_DELETE: '#tour-track-delete',
  SPREAD_WORD: '#tour-spread-word-anchor',
};

export function buildTourSteps(vm) {
  const t = key => vm.$t(key);

  return [
    {
      target: TOUR_TARGETS.WELCOME,
      header: {
        title: t('onboarding.onboardingWelcomeTitle'),
      },
      content: t('onboarding.onboardingWelcomeText'),
      params: {
        placement: 'center',
      },
    },
    {
      target: TOUR_TARGETS.SWITCH_TABS,
      header: {
        title: t('onboarding.switchTabs'),
      },
      content: t('onboarding.onboardingSwitchTabsText'),
      params: {
        placement: 'right',
      },
    },
    {
      target: TOUR_TARGETS.ITEM_UNREAD,
      header: {
        title: t('onboarding.incomingMessages'),
      },
      content: t('onboarding.onboardingIncomingMessagesText'),
      params: {
        placement: 'bottom',
      },
    },
    {
      target: TOUR_TARGETS.ITEM_REPLIED,
      header: {
        title: t('onboarding.sentReplies'),
      },
      content: t('onboarding.onboardingSentRepliesText'),
      params: {
        placement: 'bottom',
      },
    },
    {
      target: TOUR_TARGETS.ITEM_REPLY_READ,
      header: {
        title: t('onboarding.readReplies'),
      },
      content: t('onboarding.onboardingReadRepliesText'),
      params: {
        placement: 'bottom',
      },
    },
    {
      target: TOUR_TARGETS.ITEM_REPLY_REJECTED,
      header: {
        title: t('onboarding.rejectedReplies'),
      },
      content: t('onboarding.onboardingRejectedRepliesText'),
      params: {
        placement: 'bottom',
      },
    },
    {
      target: TOUR_TARGETS.ITEM_READ,
      header: {
        title: t('onboarding.readMessages'),
      },
      content: t('onboarding.onboardingReadMessagesText'),
      params: {
        placement: 'bottom',
      },
    },
    {
      target: TOUR_TARGETS.ITEM_BLOCKED,
      header: {
        title: t('onboarding.blockedContacts'),
      },
      content: t('onboarding.onboardingBlockedContactsText'),
      params: {
        placement: 'bottom',
      },
    },
    {
      target: TOUR_TARGETS.SWITCH_TABS_CONTACT,
      header: {
        title: t('onboarding.nextUp'),
      },
      content: t('onboarding.onboardingNextUpText'),
      params: {
        placement: 'right',
        highlight: false,
      },
    },
    {
      target: TOUR_TARGETS.CONTACTS_TITLE,
      header: {
        title: t('onboarding.yourContacts'),
      },
      content: t('onboarding.onboardingYourContactsText'),
      params: {
        placement: 'bottom',
        modifiers: {
          hide: {
            enabled: false,
          },
          preventOverflow: {
            boundariesElement: 'window',
          },
        },
      },
    },
    {
      target: TOUR_TARGETS.CONTACT_BLOCKED,
      header: {
        title: t('onboarding.blockedContacts'),
      },
      content: t('onboarding.onboardingBlockedContactsText2'),
      params: {
        placement: 'bottom',
        modifiers: {
          hide: {
            enabled: false,
          },
          preventOverflow: {
            boundariesElement: 'window',
          },
        },
      },
    },
    {
      target: TOUR_TARGETS.VIEWING_MESSAGES_ANCHOR,
      header: {
        title: t('onboarding.viewingMessages'),
      },
      content: t('onboarding.onboardingViewingMessagesText'),
      params: {
        placement: 'center',
        highlight: false,
      },
    },
    {
      target: TOUR_TARGETS.VIEWING_MESSAGES,
      header: {
        title: t('onboarding.viewingMessages'),
      },
      content: t('onboarding.onboardingViewingMessagesText2'),
      params: {
        placement: 'bottom',
        enableScrolling: false,
      },
    },
    {
      target: TOUR_TARGETS.PLAY_VOICE,
      header: {
        title: t('onboarding.onboardingPlayVoiceMessages'),
      },
      content: t('onboarding.onboardingPlayVoiceMessagesText'),
      params: {
        placement: 'bottom',
        enableScrolling: false,
      },
    },
    {
      target: TOUR_TARGETS.TRACK_REPLIES,
      header: {
        title: t('onboarding.onboardingTrackReplies'),
      },
      content: t('onboarding.onboardingTrackRepliesText'),
      params: {
        placement: 'top-end',
        enableScrolling: false,
        positionFixed: true,
        modifiers: {
          hide: {
            enabled: false,
          },
          preventOverflow: {
            boundariesElement: 'window',
          },
        },
      },
    },
    {
      target: TOUR_TARGETS.SEND_REPLY,
      header: {
        title: t('onboarding.sendReply'),
      },
      content: t('onboarding.onboardingSendReplyText'),
      params: {
        placement: 'top',
        enableScrolling: false,
        positionFixed: true,
        modifiers: {
          hide: {
            enabled: false,
          },
          preventOverflow: {
            boundariesElement: 'window',
          },
        },
      },
    },
    {
      target: TOUR_TARGETS.TRACK_DELETE,
      header: {
        title: t('onboarding.deleteMessages'),
      },
      content: t('onboarding.onboardingDeleteMessagesText'),
      params: {
        placement: 'bottom-end',
        enableScrolling: false,
        positionFixed: true,
        modifiers: {
          offset: {
            offset: '0, 10',
          },
          preventOverflow: {
            boundariesElement: 'window',
            padding: 10,
          },
        },
      },
    },
    {
      target: TOUR_TARGETS.SPREAD_WORD,
      header: {
        title: t('onboarding.onboardingSpreadWord'),
      },
      content: t('onboarding.onboardingSpreadWordText'),
      params: {
        placement: 'center',
        highlight: false,
      },
    },
  ];
}

export function findStepIndex(steps, target) {
  return steps.findIndex(s => s.target === target);
}

export function startTourSequence(vm) {
  const initTour = () => {
    vm.$root.$emit('change-active-mode', 'messages');
    vm.$nextTick(() => {
      vm.$root.$emit('toggle-mobile-menu', true);
      setTimeout(() => {
        if (vm.$tours && vm.$tours.purplePostTour) {
          vm.$tours.purplePostTour.start();
        } else {
          console.error('Vue-tour is missing!');
        }
      }, 500);
    });
  };

  if (vm.$route.path !== '/' && vm.$route.name !== 'dashboard') {
    vm.$router.push('/').then(initTour).catch(initTour);
  } else {
    initTour();
  }
}

export function startTourAtStep(target, vm) {
  const steps = buildTourSteps(vm);
  const idx = findStepIndex(steps, target);
  if (idx === -1) return;

  setTimeout(() => {
    if (vm.$tours && vm.$tours.purplePostTour) {
      vm.$tours.purplePostTour.start(idx);
    }
  }, 500);
}

export function endTour(vm) {
  vm.$tours.purplePostTour.stop();
  vm.$store.commit('app/SET_IS_ONBOARDING', false);
  localStorage.setItem('finished_onboarding', 'true');

  if (vm.$route.params.id === 'onboarding-post-1') {
    vm.$router.push('/');
  }
  vm.$root.$emit('change-active-mode', 'messages');
}

export function handleNextStep(currentStep, vm) {
  const steps = buildTourSteps(vm);
  const nextStepObj = steps[currentStep + 1];

  if (nextStepObj && nextStepObj.target === TOUR_TARGETS.CONTACTS_TITLE) {
    vm.$tours.purplePostTour.stop();
    vm.incrementTourResetKey();
    vm.$root.$emit('change-active-mode', 'contacts');
  }

  if (nextStepObj && nextStepObj.target === TOUR_TARGETS.VIEWING_MESSAGES) {
    vm.$tours.purplePostTour.stop();
    vm.incrementTourResetKey();
    vm.$router.push({
      name: 'post-view',
      params: {
        id: 'onboarding-post-1',
      },
    }).catch(() => {});
  }

  if (nextStepObj && [TOUR_TARGETS.TRACK_REPLIES, TOUR_TARGETS.SEND_REPLY, TOUR_TARGETS.TRACK_DELETE].includes(nextStepObj.target)) {
    return new Promise(resolve => {
      const targetElement = document.querySelector(nextStepObj.target);
      if (targetElement) {
        targetElement.scrollIntoView({
          behavior: 'smooth',
          block: 'center',
        });
        setTimeout(() => {
          window.dispatchEvent(new Event('resize'));
          resolve();
        }, 750);
      } else {
        resolve();
      }
    });
  }

  return Promise.resolve();
}

export function handlePreviousStep(currentStep, vm) {
  const steps = buildTourSteps(vm);
  const prevStepIndex = currentStep - 1;
  const prevStepObj = steps[prevStepIndex];

  if (prevStepObj && prevStepObj.target === TOUR_TARGETS.SWITCH_TABS_CONTACT) {
    vm.$tours.purplePostTour.stop();
    vm.incrementTourResetKey();
    vm.$root.$emit('change-active-mode', 'messages');

    setTimeout(() => {
      if (vm.$tours && vm.$tours.purplePostTour) {
        vm.$tours.purplePostTour.start(prevStepIndex);
      }
    }, 750);

    return Promise.resolve();
  }

  if (prevStepObj && prevStepObj.target === TOUR_TARGETS.VIEWING_MESSAGES_ANCHOR && vm.$route.name === 'post-view') {
    vm.$tours.purplePostTour.stop();
    vm.incrementTourResetKey();

    vm.$router.push('/')
      .then(() => {
        vm.$root.$emit('change-active-mode', 'contacts');
        vm.$nextTick(() => {
          vm.$root.$emit('toggle-mobile-menu', true);
          setTimeout(() => {
            if (vm.$tours && vm.$tours.purplePostTour) {
              vm.$tours.purplePostTour.start(prevStepIndex);
            }
          }, 750);
        });
      })
      .catch(() => {});

    return Promise.resolve();
  }

  if (prevStepObj && [TOUR_TARGETS.TRACK_REPLIES, TOUR_TARGETS.SEND_REPLY, TOUR_TARGETS.TRACK_DELETE].includes(prevStepObj.target)) {
    return new Promise(resolve => {
      const targetElement = document.querySelector(prevStepObj.target);
      if (targetElement) {
        targetElement.scrollIntoView({
          behavior: 'smooth',
          block: 'center',
        });
        setTimeout(() => {
          window.dispatchEvent(new Event('resize'));
          resolve();
        }, 750);
      } else {
        resolve();
      }
    });
  }
  return Promise.resolve();
}
